import React from 'react';
import { Trans as TransCommon } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import styles from './Trans.module.scss';

interface Props {
  i18nKey: string;
  values?: { [key: string]: unknown };
}

export default function Trans({ i18nKey, values }: Props) {
  if (!i18nKey) return null;

  // Extract url from values for anchor tags
  const url = values?.url as string | undefined;

  return (
    <TransCommon
      i18nKey={i18nKey}
      components={{
        a: (
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          <a
            key={uuidv4()}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          />
        ),
        br: <br key={uuidv4()} />,
        bold: <strong key={uuidv4()} />,
        li: <li key={uuidv4()} />,
        ul: <ul key={uuidv4()} />,
        ol: <ol key={uuidv4()} />,
        blue: <span className={styles.blue} key={uuidv4()} />,
      }}
      values={values}
    />
  );
}
